<script>
	import { onMount, onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import queryString from "query-string";
	import Swal from "sweetalert2";
	import client from "../../../services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
	} from "../../../store/store";
	import FuelCardManagementTable from "./FuelCardManagementTable.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import SizeSelect from "../../../components/SizeSelect/SizeSelect.svelte";
	import { extractErrorMessage } from "../../../utils/misc";

	let data = [];

	//Start Logic for filter feature
	const query = queryString.parse(window.location.search);
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let queryPage = searchParams.includes("page");
	let queryStatus = searchParams.includes("carStatus");
	let queryPlateNumber = searchParams.includes("plateNumber");
	let queryFuelCompany = searchParams.includes("fuelCompany");

	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
		initPage.set(+params.page);
	}
	$: if (!queryPage) {
		initPage.set(1);
	}
	$: if (queryStatus) {
		queryParams = queryParams.concat(`&status=${params.carStatus}`);
	}
	$: if (queryPlateNumber) {
		queryParams = queryParams.concat(`&Keyword=${params.plateNumber}`);
	}

	$: if (queryFuelCompany) {
		queryParams = queryParams.concat(
			`&FuelCompanyId=${params.fuelCompany}`
		);
	}

	//End Logic for filter feature

	//FETCH Vehicle LIST
	onMount(async () => {
		try {
			errorMessage.set("");
			loading.set(true);
			const res = await client(`/v1/fuel/cards/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			data.totalCount = res.data.totalCount;
			totalPages.set(res.data.totalPage);
			if (res.data.dataList) {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
		}
	});

	const handleInactive = async (id, status) => {
		loading.set(true);
		try {
			status = !status;
			const res = await client("/v1/fuel/cards/status", {
				method: "PUT",
				version: "Vehicle",
				data: {
					id: id,
					status: status,
				},
			});
			if (res.status === 200) {
				trigerSelectFuerlCard();
				loading.set(false);
			}
			// loading.set(false);
		} catch (error) {
			console.log(error);
			loading.set(false);
			extractErrorMessage(error);
		}
	};

	onDestroy(() => {
		initPage.set(1);
		errorMessage.set("");
		sizeSelect.set("20");
		totalPages.set(1);
	});

	const trigerSelectFuerlCard = async () => {
		try {
			loading.set(true);
			const res = await client(`/v1/fuel/cards/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			data.totalCount = res.data.totalCount;
			totalPages.set(res.data.totalPage);
			if (res.data.dataList) {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			console.log(err);
			extractErrorMessage(err);
		}
	};

	const handleResetPin = async (id) => {
		try {
			loading.set(true);
			const res = await client("/v1/fuel/cards/pin/reset", {
				method: "POST",
				version: "Vehicle",
				data: {
					cardId: id,
				},
			});
			if (res.status === 200) {
				trigerSelectFuerlCard();
			} else {
				errorMessage.set(res.data.message);
				loading.set(false);
			}
		} catch (error) {
			console.log(error.response);
			extractErrorMessage(error);
			loading.set(false);
		}
	};

	//function to handle import CSV
	let files;
	async function handleImport(e) {
		Swal.fire({
			title: `Do you want to upload this file <b class="link-text mt-2 fs-3">${e.target.files[0].name}</b>?`,
			showDenyButton: true,
			confirmButtonText: "<b>OK</b>",
			denyButtonText: `Don't upload`,
			confirmButtonColor: "#19F9B9",
			customClass: {
				confirmButton: "primary", //insert class here
			},
		}).then((result) => {
			/* Read more about isConfirmed, isDenied below */
			if (result.isConfirmed) {
				const dataArray = new FormData();
				dataArray.append("csvfile", e.target.files[0]);
				client("/v1/fuel/cards/csvFileImport", {
					method: "POST",
					version: "Vehicle",
					header: "multipart",
					data: dataArray,
				})
					.then((res) => {
						if (res.status == 200 && res.data.totalSuccess === 0) {
							Swal.fire({
								icon: "error",
								title: "Ooops!",
								text: res.data.message,
							});

							files = "";
							e.target.value = "";
						} else if (
							res.status == 200 &&
							res.data.totalSuccess !== 0
						) {
							Swal.fire({
								icon: "success",
								title: "Success!",
								text: ` Fuel card were imported`,
							}).then((res) => {
								window.location.reload();
							});
							files = "";
							e.target.value = "";
						}

						files = "";
						e.target.value = "";
					})
					.catch((err) => {
						Swal.fire({
							icon: "error",
							title: "Oops...",
							text: "Something went wrong!",
						});
						// window.location.reload();
						files = "";
						e.target.value = "";
					});
			} else if (result.isDenied) {
				Swal.fire({
					text: "Changes are not saved",
					icon: "info",
					confirmButtonColor: "#19F9B9",
					customClass: {
						confirmButton: "primary", //insert class here
					},
				});
				files = "";
				e.target.value = "";
			}
		});
	}

	const handleExportCSV = async () => {
		try {
			const res = await client("/v1/fuel/cards/csvFileExport", {
				method: "GET",
				version: "Vehicle",
				header: "csv",
			});
			const blob = new Blob([res.data], { type: "text/csv" });
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			const disposition = res.headers["content-disposition"];
			const rawFilename = disposition
				? disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1] ||
					disposition.match(/filename=([^;]+)/i)?.[1] ||
					"fuel_cards.csv"
				: "fuel_cards.csv";
			a.download = decodeURIComponent(
				rawFilename.trim().replace(/^"|"$/g, "")
			);
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			setTimeout(() => window.URL.revokeObjectURL(url), 0);
		} catch (err) {
			extractErrorMessage(err);
			console.log(err);
		}
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Fuel Card Management" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm plateNumber carStatus fuelCard fuelCompany />
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div class="mx-2">
						<Button
							class="themeButton primary px-4"
							on:click={() => handleExportCSV()}
							>Export CSV</Button
						>
					</div>
					<div class="mx-2">
						<input
							id="fileInput"
							type="file"
							multiple={false}
							hidden="hidden"
							on:change={(e) => handleImport(e)}
						/>
						<label
							type="button"
							for="fileInput"
							id="customButton"
							class="btn themeButton primary px-4"
							block>Import CSV</label
						>
						<p>
							<a
								href="/assets/csv/Fuelcard_Template.csv"
								target="_blank"
								download="Fuelcard_template.csv"
								rel="noreferrer"
								class="link link-text"
							>
								Download CSV Template
							</a>
						</p>
					</div>
					<div class="mx-2">
						<Button
							class="themeButton primary px-4"
							on:click={() =>
								navigate("/fuel-card-management/create")}
							>Create Fuel Card</Button
						>
						<div class="my-2">
							<SizeSelect trigerSelect={trigerSelectFuerlCard} />
						</div>
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<FuelCardManagementTable {data} {handleInactive} {handleResetPin} />
	</Col>
</Row>
